import { MutableRefObject, useRef, useState } from "react"
import { Note } from "../../../Data/HexMap/Note"
import { Chords } from "../../../Util/Music/Chords"
import { PositionSelector } from "../../../Util/PositionSelector/PositionSelector"
import { HxChildMap } from "../../../Comps/HxMap/HxChildMap"
import { All } from "../../../Util/Constants/Quantities"
import { OutlineBox } from "../../../Comps/OutlineBox/OutlineBox"
import { ExerciseMessage } from "../Utils/Message/ExerciseMessage"
import { NotePlayer } from "../../../Sound/NotePlayer"
import { useNotePlayer } from "../../../Sound/SoundStore"
import { Music } from "../../../Util/Music/Music"

export function ChordTypeExercise(){
    const initialMessage:string = 'What type of chord is rooted at this position?'
    const notePlayer:MutableRefObject<NotePlayer> = useRef(useNotePlayer())
    const tonic:number = Music.C
    const noteTonics:MutableRefObject<number[]> = useRef(Music.getKeyScale(tonic))

    const positionSelector:MutableRefObject<PositionSelector> = useRef(new PositionSelector(6))
    const [selectedPosition, setSelectedPosition] = useState<number>(positionSelector.current.getRandomPosition(-1))
    const [message, setMessage] = useState(initialMessage)
    const [answerStatus, setAnswerStatus] = useState<boolean|null>(null)
    const nextPosition = () => {
        setSelectedPosition(positionSelector.current.getRandomPosition())
        setAnswerStatus(null)
        setMessage(initialMessage)    
    }
    const onCorrect = () => {
        const chordNotes:number[] = Chords.GetChordNoteTonics(tonic, selectedPosition)
        notePlayer.current.playChord(chordNotes, true)
        setAnswerStatus(true)
        setMessage('Correct!')
        setTimeout(nextPosition, 1000)
    }   
    const onIncorrect = () => {
        notePlayer.current.playBuzzer()
        setAnswerStatus(false)
        setMessage('Incorrect. Try again.')
        setTimeout(clearIncorrect, 1000)
    }
    const clearIncorrect = () => {
        setAnswerStatus(null)
        setMessage(initialMessage)
    }
    const onAnswer = (chordType:string) => {
        const answer:string = Chords.GetChordType(selectedPosition)
        if(chordType === answer){onCorrect(); return}
        onIncorrect()
    }
    const replyMajor = () =>        { onAnswer(Chords.TypeMajor) }
    const replyMinor = () =>        { onAnswer(Chords.TypeMinor) }
    const replyDiminished = () =>   { onAnswer(Chords.TypeDiminished) }
    return(
        <div className={'chord-type-exercise'}>
            <OutlineBox width={700}>
                <ExerciseMessage answerStatus={answerStatus} message={message}></ExerciseMessage>
                <HxChildMap height={400} 
                            width={400} 
                            tonic={0} 
                            radius={110} 
                            definedNotes={[]}
                            hilitedNotes={[selectedPosition]}></HxChildMap>
                <div className={'buttons'}>
                        <button type='button' onClick={replyMajor}>Major</button>
                        <button type='button' onClick={replyMinor}>Minor</button>
                        <button type='button' onClick={replyDiminished}>Diminished</button>
                </div>
           </OutlineBox>


        </div>
    )
}